import type { FlagDescriptor } from '@ramp106/omrjs-core-ui/posthog'
import { createWebHistory, createRouter } from 'vue-router'

import { isFeatureEnabled } from '@/composables/useFeatureFlag'

import routes from './routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      }
    }
  },
})

function asFlag(value: unknown): FlagDescriptor | string | undefined {
  if (typeof value === 'string') return value
  if (typeof value === 'object' && value !== null && 'feature' in value && typeof (value as { feature?: unknown }).feature === 'string') {
    return value as FlagDescriptor
  }
  return undefined
}

router?.beforeEach(async (to) => {
  for (const record of to.matched) {
    const flag = asFlag(record.meta?.featureFlag)
    if (!flag) continue
    try {
      if (!(await isFeatureEnabled(flag))) {
        return { name: 'dashboard' }
      }
    } catch (error) {
      // Fail open: log and allow navigation. A throw here (e.g. non-snake_case key
      // hitting flagKey's runtime guard) would otherwise be turned into a silent
      // navigation abort by vue-router.
      console.error('[router] feature flag evaluation failed', { flag, error })
    }
  }
})

export default router
